/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Pay_Later_HintInputs */

const en_admin_resource_form_pay_later_hint = /** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitors enter their credit card, and you can charge it once the booking is complete`)
};

const de_admin_resource_form_pay_later_hint = /** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besucher geben ihre Kreditkarte ein, und du kannst sie nach Abschluss der Buchung belasten`)
};

const es_admin_resource_form_pay_later_hint = /** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus visitantes introducen su tarjeta de crédito, y tú puedes cargarla una vez finalizada la reserva`)
};

const fr_admin_resource_form_pay_later_hint = /** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les visiteurs saisissent leur carte de crédit et vous pouvez la charger une fois la réservation effectuée`)
};

/** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */
const it_admin_resource_form_pay_later_hint = en_admin_resource_form_pay_later_hint;

/** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_pay_later_hint = en_admin_resource_form_pay_later_hint;

/** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */
const pl_admin_resource_form_pay_later_hint = en_admin_resource_form_pay_later_hint;

/** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */
const hu_admin_resource_form_pay_later_hint = en_admin_resource_form_pay_later_hint;

/** @type {(inputs: Admin_Resource_Form_Pay_Later_HintInputs) => LocalizedString} */
const ro_admin_resource_form_pay_later_hint = en_admin_resource_form_pay_later_hint;

/**
* | output |
* | --- |
* | "Visitors enter their credit card, and you can charge it once the booking is complete" |
*
* @param {Admin_Resource_Form_Pay_Later_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_pay_later_hint = /** @type {((inputs?: Admin_Resource_Form_Pay_Later_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Pay_Later_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_pay_later_hint(inputs)
	if (locale === "de") return de_admin_resource_form_pay_later_hint(inputs)
	if (locale === "es") return es_admin_resource_form_pay_later_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_pay_later_hint(inputs)
	if (locale === "it") return it_admin_resource_form_pay_later_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_pay_later_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_pay_later_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_pay_later_hint(inputs)
	return ro_admin_resource_form_pay_later_hint(inputs)
});
export { admin_resource_form_pay_later_hint as "admin.resource_form.pay_later_hint" }